import React from 'react';
import { useSelector, useDispatch } from 'react-redux';
import _ from 'lodash';
import { ForgeIcon, ForgeSelect } from '@tylertech/forge-react';

import { FeatureFlags } from 'common/feature_flags';
import { I18n } from 'common/i18n';
import { getForgeIconNameForDisplayType } from 'common/displayTypeMetadata';

import * as filters from 'common/components/AssetBrowser/actions/filters';
import { selectAssetTypes } from 'common/components/AssetBrowser/selectors/filters';
import { ISelectOption } from '@tylertech/forge';

const getAssetTypeOptions = (): ISelectOption[] => {
  const scope = 'shared.asset_browser.filters.asset_types';

  const assetTypeOptions: ISelectOption[] = [
    {
      label: I18n.t('options.all', { scope }),
      value: null,
    },
    {
      label: I18n.t('options.calendars', { scope }),
      value: 'calendars',
      leadingIcon: getForgeIconNameForDisplayType('calendar'),
      leadingIconType: 'component',
    },
    {
      label: I18n.t('options.charts', { scope }),
      value: 'charts',
      leadingIcon: getForgeIconNameForDisplayType('chart'),
      leadingIconType: 'component',
    },
    {
      label: I18n.t('options.datasets', { scope }),
      value: 'datasets,system_datasets', // dataset
      leadingIcon: getForgeIconNameForDisplayType('dataset'),
      leadingIconType: 'component',
    },
    {
      label: I18n.t('options.external', { scope }),
      value: 'hrefs,federated_hrefs', // aka external datasets
      leadingIcon: getForgeIconNameForDisplayType('href'),
      leadingIconType: 'component',
    },
    {
      label: I18n.t('options.files', { scope }),
      value: 'files',
      leadingIcon: getForgeIconNameForDisplayType('attachment'),
      leadingIconType: 'component',
    },
    {
      label: I18n.t('options.filtered', { scope }),
      value: 'filters',
      leadingIcon: getForgeIconNameForDisplayType('filter'),
      leadingIconType: 'component',
    },
    {
      label: I18n.t('options.forms', { scope }),
      value: 'forms',
      leadingIcon: getForgeIconNameForDisplayType('form'),
      leadingIconType: 'component',
    },
    {
      label: I18n.t('options.maps', { scope }),
      value: 'maps',
      leadingIcon: getForgeIconNameForDisplayType('map'),
      leadingIconType: 'component',
    },
    {
      label: I18n.t('options.system_datasets', { scope }),
      value: 'system_datasets',
      leadingIcon: getForgeIconNameForDisplayType('system_dataset'),
      leadingIconType: 'component',
    },
  ];

  if (FeatureFlags.value('open_performance_standalone_measures')) {
    assetTypeOptions.push({
      label: I18n.t('options.measures', { scope }),
      value: 'measures',
      leadingIcon: getForgeIconNameForDisplayType('measure'),
      leadingIconType: 'component',
    });
  }

  if (FeatureFlags.value('stories_enabled')) {
    assetTypeOptions.push({
      label: I18n.t('options.stories', { scope }),
      value: 'stories',
      leadingIcon: getForgeIconNameForDisplayType('story'),
      leadingIconType: 'component',
    });
  }

  return assetTypeOptions;
};

export const AssetTypesFilter = () => {
  const assetTypes = useSelector(selectAssetTypes);
  const dispatch = useDispatch();

  const changeAssetType = (assetTypes: string) => {
    dispatch((filters as any).changeAssetType(assetTypes));
  };

  const scope = 'shared.asset_browser.filters.asset_types';
  const options = getAssetTypeOptions();

  return (
    <div className="filter-section asset-types">
      <label className="filter-label">{I18n.t('label', { scope })}</label>
      <ForgeSelect
        value={assetTypes || null}
        variant="filled"
        onChange={(event: CustomEvent) => {
          changeAssetType(event.detail);
        }}
        options={options}
      ></ForgeSelect>
    </div>
  );
};
